import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { AppContext } from '@prisjakt/ui-app-context';
import PlaceholderList from './placeholder-list';
import SidebarHeaderMobile from '../sidebar-mobile/sidebar-header-mobile';
import SidebarHeaderDesktop from '../sidebar-desktop/sidebar-header-desktop';

import * as S from './styles';

type Props = {
  onLoginClick?: () => void;
  onHeaderClick?: () => void;
  isMobile?: boolean;
};

const UnauthenticatedLists = ({
  onLoginClick,
  onHeaderClick,
  isMobile,
}: Props) => {
  const { t, market } = useContext(AppContext);

  return (
    <>
      {isMobile ? (
        <SidebarHeaderMobile
          title={t('lists', 'lists.title')}
          onClickHandler={onHeaderClick}
        />
      ) : (
        <SidebarHeaderDesktop title={t('lists', 'lists.title')} />
      )}

      <PlaceholderList
        icon={`${market.cdn}/g/rfe/icons/placeholders/example-list-1-icon.png`}
        variant="A"
      />
      <PlaceholderList
        icon={`${market.cdn}/g/rfe/icons/placeholders/example-list-2-icon.png`}
        variant="B"
      />
      <PlaceholderList
        icon={`${market.cdn}/g/rfe/icons/placeholders/example-list-3-icon.png`}
        variant="C"
      />

      <S.PromoText>{t('lists', 'list.empty-helper-text')}</S.PromoText>

      <S.LoginButton
        component={<Link to="/login" />}
        color="primary"
        onClick={onLoginClick}
      >
        {t('account', 'menu.not-logged-in-button')}
      </S.LoginButton>

      <S.LoginButton
        component={<Link to="/signup" />}
        variant="outlined"
        color="primary"
        onClick={onLoginClick}
      >
        {t('account', 'sign-in-promo.create-account-button')}
      </S.LoginButton>
    </>
  );
};

export default UnauthenticatedLists;
